// extracted by mini-css-extract-plugin
module.exports = {"base":"Hero_base__NvSxq","container":"Hero_container__WCPEk","headingSmall":"Hero_headingSmall__o_6lz","headingLarge":"Hero_headingLarge__D09ES","ctaBtn":"Hero_ctaBtn__LOSwt"};